import { metaFor } from './screen-meta'
import type { Access } from './types'

/**
 * Whether this person may open the screen at `path`. Founders, teammates and admins see every screen, drafts
 * included. Viewers see only the screens shared with them, and never a draft. The demo sees every screen but drafts.
 */
export function canSeeScreen(access: Pick<Access, 'screens' | 'demo'>, path: string): boolean {
  if (access.screens === null) return !(access.demo && metaFor(path)?.draft)
  if (metaFor(path)?.draft) return false
  return access.screens.includes(path)
}

/** Founders, teammates and admins build the app; viewers only look. Builders see Learn and the component board. */
export function isBuilder(access: Pick<Access, 'screens'>): boolean {
  return access.screens === null
}
